import { FaSquareMinus, FaSquarePlus } from "react-icons/fa6";
import { formatPrice } from "../../utils/helpers";
import { CartItem } from "../../types";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
import { FaRegTrashAlt } from "react-icons/fa";
import {
  addItemQty,
  reduceItemQty,
  removeItem,
  useTypedDispatch,
} from "../../store";

const ItemRecapCard: React.FC<{ item: CartItem }> = ({ item }) => {
  const dispatch = useTypedDispatch();

  const renderedModifierGroups = item.modifierGroups.map((modGroupElem) => {
    if (modGroupElem.modifierOptions?.length) {
      const renderedModifierOptions = modGroupElem.modifierOptions.map(
        (modOptionElem) => {
          const totalOptionPrice =
            modOptionElem.price.value * modOptionElem.qty;

          return (
            <div key={modOptionElem._id} className="text-gray-500 text-xs ml-2">
              • {`${modOptionElem.displayName} x${modOptionElem.qty}`}
              {totalOptionPrice > 0 && (
                <span className="text-gray-400 ml-1">{`(+${formatPrice(
                  totalOptionPrice
                )})`}</span>
              )}
            </div>
          );
        }
      );

      return (
        <div key={modGroupElem._id} className="flex flex-col mt-1">
          <div className="text-xs font-medium text-gray-700">
            {modGroupElem.displayName}:
          </div>
          {renderedModifierOptions}
        </div>
      );
    }
    return null;
  });

  const baseQtyBtnClasses =
    "w-6 h-6 cursor-pointer text-primary transition-colors hover:text-primary-dark";
  const plusBtnClasses = twMerge(
    classNames(baseQtyBtnClasses, {
      "opacity-40 cursor-not-allowed hover:text-primary": item.qty >= 10,
    })
  );
  const minusBtnClasses = twMerge(
    classNames(baseQtyBtnClasses, {
      "opacity-40 cursor-not-allowed hover:text-primary": item.qty <= 1,
    })
  );

  const handleReduceQty = () => {
    dispatch(reduceItemQty({ displayId: item.displayId }));
  };

  const handleAddQty = () => {
    dispatch(addItemQty({ displayId: item.displayId }));
  };

  const handleRemoveItem = () => {
    dispatch(removeItem({ displayId: item.displayId }));
  };

  return (
    <div className="flex gap-4 relative p-4 bg-white rounded-xl shadow-sm border border-gray-100 transition-all hover:shadow-md">
      <div className="w-20 h-20 flex-shrink-0 bg-gray-50 rounded-lg overflow-hidden flex items-center justify-center">
        <img
          src={item.imagePath}
          alt={item.displayName}
          className="w-full h-full object-contain p-1"
        />
      </div>

      <div className="flex-1 flex flex-col justify-between min-h-[5rem]">
        <div className="flex justify-between items-start">
          <div className="flex flex-col gap-0.5">
            <h3 className="font-bold text-gray-900 line-clamp-2 leading-tight">
              {item.displayName}
            </h3>
            {renderedModifierGroups && (
              <div className="mt-1">{renderedModifierGroups}</div>
            )}
          </div>

          <button
            onClick={handleRemoveItem}
            className="text-gray-400 hover:text-red-500 transition-colors p-1 -mr-2 -mt-2"
            aria-label="Remove item"
          >
            <FaRegTrashAlt className="w-4 h-4" />
          </button>
        </div>

        <div className="flex items-end justify-between mt-3">
          <div className="flex items-center gap-3 bg-gray-50 rounded-lg p-1 border border-gray-200">
            <FaSquareMinus
              className={minusBtnClasses}
              onClick={handleReduceQty}
            />
            <span className="w-6 text-center font-bold text-sm text-gray-800 tabular-nums">
              {item.qty}
            </span>
            <FaSquarePlus className={plusBtnClasses} onClick={handleAddQty} />
          </div>

          <div className="font-bold text-primary text-lg">
            {formatPrice(item.totalPrice * item.qty)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemRecapCard;
